import type { AutocompleteChangeDetails, AutocompleteChangeReason } from '@mui/material';
import type { ISelection } from 'app/ComponentLibrary/Filter/CustomSelect';

export const FACILITY_SEARCH_BLANK_TOKEN = '__FACILITY_SEARCH_BLANK__';

export const facilitySearchBlankSelection = (): ISelection =>
  ({
    id: FACILITY_SEARCH_BLANK_TOKEN,
    name: 'Blank',
    value: FACILITY_SEARCH_BLANK_TOKEN,
  }) as ISelection;

export const prependFacilitySearchBlankOption = <T extends { value?: unknown }>(options: T[] | null | undefined): T[] => {
  const blank = facilitySearchBlankSelection() as unknown as T;
  const rest = (options || []).filter(o => o?.value !== FACILITY_SEARCH_BLANK_TOKEN);
  return [blank, ...rest];
};

export const excludeFacilitySearchBlankFromOptions = <T extends { value?: unknown }>(options: T[] | null | undefined) =>
  (options || []).filter(o => o?.value !== FACILITY_SEARCH_BLANK_TOKEN);

export const facilitySearchBlankMultiSelectHandleChange = (
  choice: ISelection[] | null,
  _reason: AutocompleteChangeReason,
  details: AutocompleteChangeDetails<ISelection>,
  onChange: (v: ISelection[] | null) => void,
) => {
  if (!Array.isArray(choice)) {
    onChange(choice);
    return;
  }

  const blank = facilitySearchBlankSelection();
  const clicked = details?.option as ISelection | undefined;
  const hasBlank = (arr: ISelection[]) => arr?.some(i => i?.value === FACILITY_SEARCH_BLANK_TOKEN);

  if (clicked?.value === FACILITY_SEARCH_BLANK_TOKEN) {
    if (hasBlank(choice)) {
      onChange([blank]);
      return;
    }
  }

  if (hasBlank(choice) && clicked?.value !== FACILITY_SEARCH_BLANK_TOKEN) {
    onChange(choice.filter(i => i?.value !== FACILITY_SEARCH_BLANK_TOKEN));
    return;
  }

  onChange(choice);
};

export const mapFacilitySearchBlankTokenToNull = (v: unknown) => (v === FACILITY_SEARCH_BLANK_TOKEN ? null : v);
